import { useApi } from "./api-service";
import { E164Number } from "../../types/agent-settings";

export function useCallersService() {
  const agentRequired = true;
  const callersApi = useApi(agentRequired);

  return {
    fetchBlockedCallers: async (): Promise<E164Number[]> => {
      return callersApi.get<E164Number[]>("/blocked-callers");
    },

    addBlockedCaller: async (phoneNumber: E164Number): Promise<void> => {
      return callersApi.post<void>("/blocked-callers", { phoneNumber });
    },

    deleteBlockedCaller: async (phoneNumber: E164Number): Promise<void> => {
      return callersApi.delete<void>(`/blocked-callers/${phoneNumber}`);
    },
  };
}
